import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center py-1 bg-light border-top mt-auto" style={{ fontSize: "0.7rem", fontWeight: 600 }}>
      <small>&copy; {currentYear} Ascension-q. all right reserved.</small>
    </footer>
  );
};

export default Footer;
